<template>
  <div id="grid-recepcion">
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
          </v-card-actions>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsDocumento"
            hide-actions
            :pagination.sync="miPaginacion"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.nivel }}</td>
              <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
              <td class="text-xs-left">{{ props.item.region }}</td>
              <td class="text-xs-left">{{ props.item.fechaInicio }}</td>
              <td class="text-xs-left">{{ props.item.fechaFin }}</td>
              <td class="text-xs-left">{{ props.item.dias }}</td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Ver Cajas Recibidas"
                  @click="editRecepcion(props.item.id, props.item.idSubitem)"
                >
                  <v-icon>open_in_new</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <!-- PAGINACION -->
      <v-flex xs12 sm6>
        <v-text-field
          value=""
          label="Total de Registros"
          v-model="itemsDocumento.length"
          disabled
        ></v-text-field>
      </v-flex>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="miPaginacion.page"
          :length="nPaginas"
          :total-visible="5"
          circle
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "grid-recepcion",
  components: {},
  props: {
    itemsDocumento: "",
    rowsTable: {
      type: Number,
      required: true,
    },
    nPaginas: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      miPaginacion: {
        rowsPerPage: 20,
        totalItems: 0,
      },
      contratoId: "",
      usuario: "",
      proceso: "",
      tipoUsuario: "",
      tipeArchive: "",
      headers: [
        {
          text: "Nivel",
          align: "left",
          sortable: false,
          value: "nivel",
        },
        { text: "Tipo de Prueba", sortable: false, value: "fechaEntrega" },
        { text: "Region", sortable: false, value: "fechaActualizacion" },
        {
          text: "Fecha Inicio Distribución",
          sortable: false,
          value: "fechaProgreso",
        },
        {
          text: "Fecha Recepción Distribución",
          sortable: false,
          value: "fechaProgreso",
        },
        { text: "Días Distribución", sortable: false, value: "fechaProgreso" },
        {
          text: "Accion",
          sortable: false,
          value: "",
        },
      ],
    };
  },
  created() {
    this.subProceso = this.$store.getters.subProTabSelectedStored;
    this.idContrato = this.$store.getters.contratoStored;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.tipoUsuario = this.$store.getters.userLogged.tipo;
    this.tipeArchive = ".xlsx";
  },

  mounted() {
    this.miPaginacion.rowsPerPage = this.rowsTable;
  },
  computed: {},
  methods: {
    editRecepcion(id, idSubitem) {
      setTimeout(() => {
        this.$router.push({
          name: "FormRecepcion",
          params: { tipeView: "consulta", idSubitem: idSubitem, idAcuerdo: id },
        });
      }, 1000);
    },
  },
};
</script>
